import useSWR from 'swr';

const subscriptionFetcher = async (url) => {
    const rsp = await fetch(url);
    if (!rsp.ok) {
        const error = new Error("Request failed");
        error.status = rsp.status;
        error.info = await rsp.text().catch(() => null);
        throw error;
    }
    return rsp.json();
};

const useSubscription = (owner) => {
    return useSWR(owner ? `/api/installation/${owner}` : null, subscriptionFetcher);
};

export default useSubscription;
